module.exports = __webpack_public_path__ + "static/media/u-trapp-vanster.0e03cb82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/u-trapp-vanster.png
// module id = 39
// module chunks = 0